/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-06 10:30:38
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo, Integer} from "src/types/base";
export declare namespace SaasAccountConfigDOI {

	export interface RowDataI {
		account_name: string
		real_name: string
		mobile: string
		id: number
		system_name: string
		english_system_name: string
	}

	export interface QueryRowDataParamsI extends PageDo {
		keyword?: string
	}


	export interface OperateParamsI {
        user_id?: Integer
		account_name: string
        name: string
        mobile: string
        passwords?: string
		expiration_time?: Integer
	}

}
export default class SaasAccountConfigApi {
	/**
	 * 查询列表
	 * @param {SaasAccountConfigDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: SaasAccountConfigDOI.QueryRowDataParamsI):Promise<ResultPageDo<SaasAccountConfigDOI.RowDataI[]>> {
		return Api.post('/auth_login/account/saas/qurey', params)
	}
	
	/**
	 * 新增
	 * @param {SaasAccountConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async add(data:SaasAccountConfigDOI.OperateParamsI):Promise<Result<any>> {
		return Api.post('/auth_login/account/saas/add', data)
	}

	/**
	 * 修改
	 * @param {SaasAccountConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async update(data:SaasAccountConfigDOI.OperateParamsI):Promise<Result<any>> {
		return Api.post('/auth_login/account/saas/edit', data)
	}

	/**
	 * 删除
	 * @param {Array<number>} data
	 * @returns {Promise<Result<any>>}
	 */
	static async delete(user_id: number):Promise<Result<any>> {
		return Api.post('/auth_login/account/saas/delete', {user_id})
    }
    
    static async querySaasList():Promise<Result<{account_name: string,enterprise_id: number,real_name: string}[]>> {
		return Api.post('/auth_login/account/saas/list')
	}
}